import type { CatalogCountry } from '@/services/api/registers'
import { cn } from '@/utils/cn'

/** Typographic jurisdiction tag — a small monospaced stamp (CZ / SK / INTL) with a fixed categorical hue per country. */
const TONE: Record<CatalogCountry, string> = {
  CZ: 'bg-cat-1/10 text-cat-1 border-cat-1/30',
  SK: 'bg-cat-4/10 text-cat-4 border-cat-4/30',
  INTL: 'bg-muted text-muted-foreground border-border',
}

export function CountryTag({
  country,
  className,
}: {
  country: CatalogCountry
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex h-5 shrink-0 items-center rounded-sm border px-1.5 font-mono text-2xs font-semibold uppercase tracking-[0.14em]',
        TONE[country],
        className
      )}
    >
      {country}
    </span>
  )
}
